import styled from 'styled-components';

interface RadioboxProps {
  readonly disabled?: boolean;
}

export const Radiobox = styled.span<RadioboxProps>`
  display: inline-flex;
  position: relative;

  label {
    position: relative;
    padding-left: 2.8rem;
    line-height: 2rem;
    display: inline-flex;
    cursor: pointer;
  }

  [type='radio'] {
    position: absolute;
    left: -9999px;
  }

  label:after {
    content: '';
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    top: 0.4rem;
    left: 0.3rem;
    border-radius: 100%;
    opacity: 0;
    transform: scale(0);
    transition: all 0.2s ease;
    background: #2276e3;
  }

  label:before {
    content: '';
    width: 1.8rem;
    height: 1.8rem;
    position: absolute;
    left: 0;
    top: 0.1rem;
    border-radius: 100%;
    background: #fff;
    border: 0.1rem solid #647a97;
  }

  [type='radio']:checked + label:before {
    border: 0.1rem solid #2276e3;
  }

  [type='radio']:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }

  @media (min-width: 768px) {
    /* display: flex; */
  }

  &.disabled {
    background: #eee;
    color: #666;
  }
`;
